import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Heart, User, Sparkles, Shield, Brain } from 'lucide-react';

const GoalStep = ({ data, updateData, onNext }) => {
  const [selectedGoal, setSelectedGoal] = useState(data.goal || '');

  const goals = [
    { id: 'romantic', label: 'Romantic Roleplaying', icon: Heart },
    { id: 'friend', label: 'Creating a personal friend', icon: User },
    { id: 'flirting', label: 'Flirting and love', icon: Sparkles },
    { id: 'safe-space', label: 'A safe, non-judgmental place', icon: Shield },
    { id: 'exploring', label: 'Exploring AI capabilities', icon: Brain }
  ];

  const handleSelect = (goalId) => {
    setSelectedGoal(goalId);
    updateData('goal', goalId);
  };

  const handleContinue = () => {
    if (selectedGoal) {
      onNext();
    }
  };

  return (
    <div className="text-center">
      <h1 className="text-white text-2xl md:text-3xl font-bold mb-4">
        Select your goal
      </h1>
      <p className="text-white/70 text-sm md:text-base mb-8">
        Please tell us what you're looking for. It'll help us personalize your experience.
      </p>

      <div className="space-y-4 mb-8">
        {goals.map((goal) => {
          const IconComponent = goal.icon;
          return (
            <button
              key={goal.id}
              onClick={() => handleSelect(goal.id)}
              className={`w-full py-4 px-6 rounded-full text-base md:text-lg font-bold transition-all duration-300 hover:scale-105 flex items-center justify-center gap-3 ${
                selectedGoal === goal.id
                  ? 'bg-[#F1B428] text-black shadow-lg shadow-[#F1B428]/30 scale-105'
                  : 'bg-white/5 backdrop-blur-sm text-white border border-white/10 hover:border-[#F1B428]/50'
              }`}
            >
              <IconComponent size={20} />
              {goal.label}
            </button>
          );
        })}
      </div>

      <Button
        onClick={handleContinue}
        disabled={!selectedGoal}
        className="w-full max-w-sm bg-[#F1B428] hover:bg-[#D9A022] text-black font-bold text-lg py-6 rounded-full transition-all duration-300 hover:scale-105 shadow-lg shadow-[#F1B428]/30 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Continue
      </Button>
    </div>
  );
};

export default GoalStep;
